export { default } from './DestacatCercadorPrevisio';
